import { render } from "./LoansGrid.vue?vue&type=template&id=659edbd0"
import script from "./LoansGrid.vue?vue&type=script&lang=js"
export * from "./LoansGrid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__